module.exports = __webpack_public_path__ + "static/media/street_figure_pricing_page.61a3473a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/street_figure_pricing_page.svg
// module id = 568
// module chunks = 0